import { Resource } from './resource';
import { Filter } from './filters';
import { Sort, SortDirection, SortColumn } from '../types/sort';
import { Organization, Space } from './api';

export type ImplementedState = {
  selectedSpaceIds: Array<Space['external_id']>;

  organizations: Array<{ id: string; name: string }>;

  filters: Array<Filter>;
  searchText: string;
  sort: Sort;

  page: number;

  resource: Resource<{
    total: number;
    spaces: Array<Space>;
    fetchingMoreSpaces: Resource<null>; // There is no data in this resource, it's only used as a status
  }>;
};

export enum ImplementedActionTypes {
  IMPLEMENTED_CHANGE_PAGE = 'IMPLEMENTED_CHANGE_PAGE',

  IMPLEMENTED_LOAD_START = 'IMPLEMENTED_LOAD_START',
  IMPLEMENTED_LOAD_ERROR = 'IMPLEMENTED_LOAD_ERROR',
  IMPLEMENTED_LOAD_COMPLETE = 'IMPLEMENTED_LOAD_COMPLETE',

  IMPLEMENTED_SET_FILTERS = 'IMPLEMENTED_SET_FILTERS',
  IMPLEMENTED_SET_SEARCH_TEXT = 'IMPLEMENTED_SET_SEARCH_TEXT',
  IMPLEMENTED_SET_SORT = 'IMPLEMENTED_SET_SORT',

  IMPLEMENTED_CHANGE_CHECKS = 'IMPLEMENTED_CHANGE_CHECKS',

  IMPLEMENTED_SET_PAGE = 'IMPLEMENTED_SET_PAGE',
  IMPLEMENTED_NEXT_PAGE_LOAD_LOADING = 'IMPLEMENTED_NEXT_PAGE_LOAD_LOADING',
  IMPLEMENTED_NEXT_PAGE_LOAD_ERROR = 'IMPLEMENTED_NEXT_PAGE_LOAD_ERROR',
  IMPLEMENTED_NEXT_PAGE_LOAD_COMPLETE = 'IMPLEMENTED_NEXT_PAGE_LOAD_COMPLETE',
}

export type ImplementedAction =
  | {
      type: ImplementedActionTypes.IMPLEMENTED_CHANGE_PAGE;
      searchText: string;
      filters: Array<Filter>;
      sort: Sort;
      organizationId: Organization['id'] | null;
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_LOAD_START;
      page: 'list' | 'detail';
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_LOAD_ERROR;
      page: 'list' | 'detail';
      error: any;
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_LOAD_COMPLETE;
      spaces: Array<Space>;
      total: number;
      organizations: Array<{ id: string; name: string }>;
      searchText: string;
      filters: Array<Filter>;
      sort: Sort;
    }
  | { type: ImplementedActionTypes.IMPLEMENTED_SET_SEARCH_TEXT; text: string }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_SET_FILTERS;
      filters: Array<Filter>;
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_SET_SORT;
      direction: SortDirection;
      column: SortColumn;
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_CHANGE_CHECKS;
      ids: Array<string>;
      checked: boolean;
    }
  | { type: ImplementedActionTypes.IMPLEMENTED_SET_PAGE; value: number }
  | { type: ImplementedActionTypes.IMPLEMENTED_NEXT_PAGE_LOAD_LOADING }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_NEXT_PAGE_LOAD_ERROR;
      error: any;
    }
  | {
      type: ImplementedActionTypes.IMPLEMENTED_NEXT_PAGE_LOAD_COMPLETE;
      spaces: Array<Space>;
    };
